import { useCallback } from 'react';

import * as events from 'src/lib/events';
import { PAGES, useTrackingEvent } from 'src/services/useTrackingEvent';

import { useMainActions } from '../store';

import { useGetProjectAttributes } from './useGetProjectAttributes';

export const useListViewEvents = () => {
  const mainActions = useMainActions();
  const trackingEvent = useTrackingEvent();
  const getProjectAttributes = useGetProjectAttributes();

  const trackViewedHistoryResultDetails = useCallback(
    (requestId) => {
      const attributes = {
        ...getProjectAttributes(),
        generationTool: mainActions.getGenerationTool(),
        page: PAGES.editor,
        requestId,
      };

      trackingEvent(events.DOCUMENT.viewedHistoryResultDetails, attributes);
    },
    [trackingEvent, getProjectAttributes, mainActions]
  );

  const trackInitiatedPublishFlow = useCallback(
    ({ generationTool, channel, variationIds }) => {
      trackingEvent(events.DOCUMENT.initiatedPublishFlow, {
        ...getProjectAttributes(),
        page: PAGES.editor,
        generationTool,
        variationIds,
        isGroupExport: variationIds.length > 1,
        exportTarget: channel,
      });
    },
    [trackingEvent, getProjectAttributes]
  );

  return {
    trackViewedHistoryResultDetails,
    trackInitiatedPublishFlow,
  };
};
